import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Typography, Box, IconButton, TextField
    , FormControl, InputLabel, Select } from '@mui/material';
import { PersonAdd as IconPersonAdd, IndeterminateCheckBox as IconIndeterminateCheckBox
    , CheckBox as IconCheckBox } from "@mui/icons-material";
import { Link } from "react-router-dom";
import * as evaluacionService from "../../services/evaluacionService";
import * as catalogoService from "../../services/catalogoService";
import DataGridBase from "../../components/common/DataGridBase"
import { useMantenimiento } from "../../hooks/useMantenimiento";
import DialogYesNo from '../../components/DialogYesNo';
import moment from "moment";

// Navegabilidad de los objetivos asignados a los participantes: la lista que
// se sigue, con filtros por participante (texto), tema y estado.
const Index = () => {
const { isReadOnly } = useMantenimiento("evaluacion");
    const [results, setResults] = useState([]);
    const [listTemas, setListTemas] = useState([]);
    const [listEstados, setListEstados] = useState([]);
    const [member, setMember] = useState("");
    const [idTema, setIdTema] = useState(0);
    const [idEstado, setIdEstado] = useState(0);
    const [cargando, setCargando] = useState(true);
    const [openDialogAnnulActive, setOpenDialogAnnulActive] = useState(false);
    const [selectId, setSelectId] = useState(null);
    const [selectState, setSelectState] = useState(null);
    const navigate = useNavigate();

    const fetchTemas = useCallback(async () => {
        const data = await evaluacionService.getsTemaEvaluacionView()
            .catch((err) => {
                console.log("Err: ", err);
                return [];
            });

        setListTemas((data || []).filter((row) => row.idTemaPadre != null));
    }, [])

    const fetchEstados = useCallback(async () => {
        const data = await catalogoService.getCatalogosByPadre(1)
            .catch((err) => {
                console.log("Err: ", err);
                return [];
            });

        setListEstados(data || []);
    }, [])

    const fetchResults = useCallback(async () => {
        setCargando(true);

        await evaluacionService.getsParticipanteObjetivoView(0)
            .then((data) => {
                let lista = data || [];

                if (member.trim() !== "") {
                    lista = lista.filter((row) => (row.participante || "").toLowerCase()
                        .includes(member.toLowerCase()));
                }

                if (idTema > 0) {
                    lista = lista.filter((row) => row.idTemaEvaluacion == idTema);
                }

                if (idEstado > 0) {
                    lista = lista.filter((row) => row.idEstado == idEstado);
                }

                setResults(lista);
                setCargando(false);
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
            });
    }, [member, idTema, idEstado])

    useEffect(() => {
        fetchTemas();
        fetchEstados();
    }, [fetchTemas, fetchEstados])

    useEffect(() => {
        fetchResults();
    }, [fetchResults])

    const annul = async () => {
        await evaluacionService.annulParticipanteObjetivo(selectId)
            .catch((err) => {
                console.log("Err: ", err);
            });
        fetchResults();
    }

    const active = async () => {
        await evaluacionService.activeParticipanteObjetivo(selectId)
            .catch((err) => {
                console.log("Err: ", err);
            });
        fetchResults();
    }

    const columnas = useMemo(() => [
        { field: 'id', headerName: 'ID', width: 50, minWidth: 45, sortable: true, headerAlign: 'center', align: 'center',
            renderCell: (p) => <span style={{ fontSize: '0.75rem', color: '#666', fontFamily: 'monospace' }}>{p.value != null ? p.value : p.row.id}</span> },
        { field: 'participante', headerName: 'Participante', width: 200, sortable: false, headerAlign: 'center'
            , renderCell: (cellValues) => {
                return (
                    <Link to={'/participanteobjetivo/edit/' + cellValues.row.id + '/' + cellValues.row.idParticipante}
                        style={{ color: 'inherit' }}>
                        {cellValues.row.participante}
                    </Link>
                );
            }
        },
        { field: 'nombre', headerName: 'Objetivo', width: 240, sortable: false, headerAlign: 'center' },
        { field: 'tema', headerName: 'Tema', width: 190, sortable: false, headerAlign: 'center' },
        { field: 'fechaInicio', headerName: 'Fecha', width: 110, sortable: false, headerAlign: 'center', align: 'center'
            , valueFormatter: (value) => (value && moment(value).isValid() ? moment(value).format("DD/MM/YYYY") : "")
        },
        { field: 'valorInicial', headerName: 'Valor inicial', width: 160, sortable: false, headerAlign: 'center' },
        { field: 'criterioLogro', headerName: 'Criterio de logro', width: 200, sortable: false, headerAlign: 'center' },
        { field: 'estado', headerName: 'Estado', width: 90, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'anular', headerName: '', width: 80, sortable: false, headerAlign: 'center', align: 'center'
            , renderCell: (cellValues) => {
                return <IconButton aria-label="anular" size='small' style={{ height: 10 }} align={"center"} onClick={() => {
                    setSelectId(cellValues.row.id);
                    setSelectState(cellValues.row.estado);
                    setOpenDialogAnnulActive(true);
                }}>
                    { cellValues.row.estado == "A" ? <IconIndeterminateCheckBox /> : <IconCheckBox /> }
                </IconButton>;
            }
        },
    ], [])

    return (
        <div>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Objetivos de Participantes
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <Grid container item xs={12} sm={12} spacing={1}>
                        <Grid item xs={12} sm={4}>
                            <TextField
                                name="member"
                                label="Participante"
                                fullWidth
                                value={member}
                                onChange={(event) => {
                                    setMember(event.target.value)
                                }}
                                onKeyDown={(event) => {
                                    if (event.key === "Enter") {
                                        event.preventDefault();
                                        fetchResults();
                                    }
                                }}
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={8} sm={3}>
                            <FormControl fullWidth>
                                <InputLabel htmlFor="input-tema" shrink>Tema</InputLabel>
                                <Select
                                    native
                                    label="Tema"
                                    value={idTema}
                                    onChange={(event) => {
                                        setIdTema(parseInt(event.target.value || "0"))
                                    }}
                                    inputProps={{
                                        name: 'idTema',
                                        id: 'input-tema',
                                    }}
                                    size="small"
                                >
                                    <option key={0} value={0}>{"(Todos)"}</option>
                                    {listTemas.map((row) => (
                                        <option key={row.id} value={row.id}>{row.temaPadre + " - " + row.nombre}</option>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={8} sm={3}>
                            <FormControl fullWidth>
                                <InputLabel htmlFor="input-estado" shrink>Estado</InputLabel>
                                <Select
                                    native
                                    label="Estado"
                                    value={idEstado}
                                    onChange={(event) => {
                                        setIdEstado(parseInt(event.target.value || "0"))
                                    }}
                                    inputProps={{
                                        name: 'idEstado',
                                        id: 'input-estado',
                                    }}
                                    size="small"
                                >
                                    <option key={0} value={0}>{"(Todos)"}</option>
                                    <option key={2} value={2}>{"Activo"}</option>
                                    <option key={4} value={4}>{"Anulado"}</option>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                        <DataGridBase
                            rows={results}
                            columns={columnas}
                            loading={cargando}
                            toolbarButtons={[
                                {
                                    text: "NUEVO",
                                    icon: <IconPersonAdd />,
                                    disabled: isReadOnly,
                                    onClick: () => navigate("/participanteobjetivo/edit/0/0")
                                }
                            ]}
                        />
                    </Box>
                </Grid>
                <DialogYesNo open={openDialogAnnulActive} openClose={() => { setOpenDialogAnnulActive(!openDialogAnnulActive) }} setYes={ selectState == "A" ? annul : active}
                    setNo={() => { return }}
                    titulo={(selectState == "A" ? "Anular" : "Activar") + " Objetivo"}
                    texto={"Esta seguro de " + (selectState == "A" ? "anular" : "activar") + " el objetivo?"} >
                </DialogYesNo>
            </Grid>
        </div>
    )
}

export default Index
